import { axios } from "@cores/axiosWrapper";

export const getReportAPI = (stageId, apiEndpoint, projectId, id) => {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }

    return axios.get(`${apiEndpoint}/reports/${id}`, {
        headers,
    });
};

export const getReportEmailRecipientsAPI = (stageId, apiEndpoint, projectId, id, params) => {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }

    return axios.get(`${apiEndpoint}/reports/${id}/subscribers`, {
        headers,
        params,
    });
};
